export default function Services() {
    const services = [
        { name: "Web Development", image: "/images/web-development.png" },
        { name: "App Development", image: "/images/app-development.png" },
        { name: "Graphics Design", image: "/images/graphics.png" },
        { name: "Maintenance", image: "/images/maintenance.png" }
    ];

    return (
        <section id="services" className="px-5 lg:px-10 py-10 w-full my-20 max-w-5xl mx-auto bg-orange-100">
            <h2 className="text-center text-6xl text-orange-400 font-bold">
                Our Services
            </h2>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {services.map((service, index) => (
                    <div 
                        key={index}
                        className="cursor-pointer p-6 rounded bg-orange-100 text-lg flex flex-col items-center justify-center font-bold hover:shadow-xl transition-shadow duration-300"
                        aria-label={service.name}
                    >
                        <img 
                            src={service.image} 
                            alt={`${service.name} icon`} 
                            className="w-16 h-16 mb-4" 
                        />
                        <span>{service.name}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}